require('smoothscroll-polyfill').polyfill();
import { getMainHeaderHeight, toTop, getButtonVisibleClass } from './Helper';

export default class ScrollTop {
    constructor(button) {
        this.button = button;
        this.scrolled = false;
        this.onScroll = this.onScroll.bind(this);
        this.mainHeaderHeight = getMainHeaderHeight();
        this.update = this.update.bind(this);
        this.pageY = 0;
    }

    init() {
        this.button.addEventListener('click', toTop);
        window.addEventListener('scroll', this.onScroll);
        window.requestAnimationFrame(this.update);
    }

    update() {
        if (this.scrolled) {
            if (this.pageY >= this.mainHeaderHeight) {
                this.button.classList.add(getButtonVisibleClass());
            } else {
                this.button.classList.remove(getButtonVisibleClass());
            }
            this.scrolled = false;
        }
        window.requestAnimationFrame(this.update);
    }

    onScroll() {
        this.pageY = window.pageYOffset;
        this.scrolled = true;
    }
}



// WEBPACK FOOTER //
// ./wp-content/themes/template/js/src/Modules/ScrollTop.js